import { render, staticRenderFns } from "./cartNum.vue?vue&type=template&id=7b0f5c5e&"
import script from "./cartNum.vue?vue&type=script&lang=js&"
export * from "./cartNum.vue?vue&type=script&lang=js&"
import style0 from "./cartNum.vue?vue&type=style&index=0&id=7b0f5c5e&prod&lang=scss&rel=stylesheet%2Fscss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports